import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import ClipboardView from '../views/ClipboardView.vue'
import Documentation from '../views/Documentation.vue'
import EntryView from '../views/EntryView.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/docs',
    name: 'Documentation',
    component: Documentation
  },
  {
    path: '/entries/:uniqueId',
    name: 'EntryView',
    component: EntryView,
    props: true
  },
  {
    path: '/:clipboardId',
    name: 'ClipboardView',
    component: ClipboardView,
    props: true
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router 